var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultStepIcon = function SvgDefaultStepIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M12 1.255c5.937 0 10.75 4.812 10.75 10.75S17.937 22.755 12 22.755 1.25 17.942 1.25 12.005 6.063 1.255 12 1.255m4.676 7.012a1 1 0 0 0-1.413.062l-4.794 5.23-1.762-1.761a1 1 0 1 0-1.414 1.413l2.5 2.5a1 1 0 0 0 1.444-.03l5.5-6a1 1 0 0 0-.061-1.414"
  })));
};
export default SvgDefaultStepIcon;